import styled from 'styled-components';

export const ResetPasswordInvalid = () => <Root>The link is not active or invalid</Root>;

const Root = styled.div`
  padding-top: ${({ theme }) => theme.spacings.xlarge};
  display: flex;
  justify-content: center;
`;
